// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartShippingSummaryDisplayStyles } from "@guestsupply/App/Components/Cart/CartShippingSummaryDisplay";
import cartSummarySharedStyles from "@guestsupply/App/SharedStyles/CartSummarySharedStyles";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

cartShippingSummaryDisplayStyles.container = {
    ...cartSummarySharedStyles.container,
};
cartShippingSummaryDisplayStyles.titleGridItem = {
    ...cartSummarySharedStyles.titleGridItem,
};
cartShippingSummaryDisplayStyles.titleText = {
    ...cartSummarySharedStyles.titleText,
};
cartShippingSummaryDisplayStyles.labelGridItem = { ...cartSummarySharedStyles.labelGridItem };
cartShippingSummaryDisplayStyles.valueGridItem = { ...cartSummarySharedStyles.valueGridItem };
cartShippingSummaryDisplayStyles.subtotalValue = {
    ...cartSummarySharedStyles.valueText,
};
cartShippingSummaryDisplayStyles.subtotalLabel = {
    ...cartSummarySharedStyles.labelText,
};
cartShippingSummaryDisplayStyles.tooltipStyles = {
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            margin-left: 8px;
            svg {
                height: 12px;
                width: 12px;
            }
        `,
    },
};
cartShippingSummaryDisplayStyles.wrapper = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};
cartShippingSummaryDisplayStyles.freeShippingStyle = {
    css: css`
        ${xScreen("lte", "md")} {
            max-width: 90px;
        }
        ${xScreen("lte", "sm")} {
            max-width: inherit;
        }
    `,
};
